import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
    FaFacebookF,
    FaInstagram,
    FaYoutube,
    FaEnvelope,
    FaPhoneAlt,
    FaMapMarkerAlt
} from "react-icons/fa";

const Footer = () => {
    return (
        <footer className="footer-section">
            <Container>

                <Row>

                    {/* BRAND COLUMN */}
                    <Col lg={4} md={6} className="mb-4">
                        <div className="footer-brand">

                            <div as={Link} to="/" className="brand-logo pb-2">
                                <img
                                    src="/images/img/Logo.png"
                                    alt="Hindustan Agro Life"
                                    className="logo-img"
                                />
                                <div className="brand-text-wrap">
                                    <span className="brand-title">Hindustan</span>
                                    <span className="brand-subtitle">Agro Life</span>
                                </div>
                            </div>

                            <p>
                                Hindustan Agro Life is a responsible agricultural solutions
                                company delivering eco-friendly, reliable, and field-proven
                                crop care products for Indian farmers.
                            </p>

                            <Link to="/contact" className="footer-btn">
                                Get in Touch
                            </Link>

                            {/* SOCIAL */}
                            <div className="footer-social">
                                <a href="https://www.facebook.com/share/1An7W383jd/" aria-label="Facebook">
                                    <FaFacebookF />
                                </a>
                                <a href="https://www.instagram.com/hindustanagrolife" aria-label="Instagram">
                                    <FaInstagram />
                                </a>
                                <a href="https://www.youtube.com/@HindustanAgroLife" aria-label="LinkedIn">
                                    <FaYoutube />
                                </a>
                            </div>
                        </div>
                    </Col>

                    {/* QUICK LINKS */}
                    <Col lg={2} md={6} className="mb-4">
                        <h5 className="footer-title">Quick Links</h5>
                        <ul className="footer-links">
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/products">Products</Link></li>
                            <li><Link to="/contact">Contact</Link></li>
                        </ul>
                    </Col>

                    {/* CATEGORIES */}
                    <Col lg={3} md={6} className="mb-4">
                        <h5 className="footer-title">Product Categories</h5>
                        <ul className="footer-links">
                            <li><Link to="/category/insecticides">Insecticides</Link></li>
                            <li><Link to="/category/fungicides">Fungicides</Link></li>
                            <li><Link to="/category/herbicides">Herbicides</Link></li>
                            <li><Link to="/category/plant-growth-regulators">Plant Growth Regulators</Link></li>
                            <li><Link to="/category/fertilizers">Fertilizers</Link></li>
                            <li><Link to="/category/NPK-Fertilizer">NPK Fertilizer</Link></li>
                        </ul>
                    </Col>

                    {/* CONTACT INFO */}
                    <Col lg={3} md={6} className="mb-4">
                        <h5 className="footer-title">Contact Info</h5>

                        <ul className="footer-contact">
                            <li>
                                <FaEnvelope />
                                <a href="mailto:hindustanagrolife@gmail.com">
                                    hindustanagrolife@gmail.com
                                </a>
                            </li>

                            <li>
                                <FaPhoneAlt />
                                <a href="tel:+919243215585">
                                    +91 9243215585
                                </a>
                            </li>

                            <li>
                                <FaMapMarkerAlt />
                                <a
                                    href="https://maps.app.goo.gl/wUWw86a1dye9YdjN8"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Ratlam, Madhya Pradesh-457001, India
                                </a>
                            </li>
                            <li>
                                <FaMapMarkerAlt />
                                <a
                                    href="https://maps.app.goo.gl/wUWw86a1dye9YdjN8"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Rajkot, Gujarat – 360024, India
                                </a>
                            </li>
                        </ul>
                    </Col>

                </Row>

                {/* FOOTER BOTTOM */}
                <div className="footer-bottom">
                    <p>
                        © {new Date().getFullYear()} Hindustan Agro Life. All Rights Reserved. <br />
                        Made by{" "}
                        <a
                            href="https://taaksoftech.com"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Taak Softech Pvt. Ltd.
                        </a>
                    </p>
                </div>

            </Container>
        </footer>
    );
};

export default Footer;
